import { useEffect, useState } from 'react';
import { useV2 } from './ctx';
import { Piutang } from './Ringkasan';

// Lainnya: everything that isn't daily work. Laba Rugi, plan loading and
// month close, ritase log, and the escape hatch back to the old screens.
// These reuse the existing App.js screens (passed in as `legacy`) so the
// rollout doesn't rewrite flows nobody asked to change.
export default function Lainnya() {
  const { legacy, data, role, monthKey, refresh, user, logout, setUi, appVersion } = useV2();
  const [open, setOpen] = useState(null);
  const L = legacy;
  const sections = [
    { id: 'pl', t: 'Laba Rugi', s: 'P&L bulan ini' },
    { id: 'plan', t: 'Plan bulanan', s: data?.plan ? 'Muat ulang plan atau tutup bulan' : 'Muat plan dari SharePoint' },
    { id: 'rit', t: 'Log ritase', s: 'Setiap rit yang tercatat bulan ini' },
    // Moved off Ringkasan (Director, 3 Oct: "what is the piutang accurate table for?") until it's tied to plan lines.
    { id: 'piut', t: 'Piutang (Accurate)', s: 'Faktur yang belum dibayar customer' },
  ];
  return (
    <div className="v2-page" style={{ maxWidth: 900 }}>
      <div className="v2-head"><div><h2>Lainnya</h2></div></div>
      <div className="group">
        {sections.map(x => (
          <div key={x.id}>
            <div className="row tap" onClick={() => setOpen(open === x.id ? null : x.id)}><div className="grow"><div className="t" style={{ fontWeight: 600 }}>{x.t}</div><div className="m">{x.s}</div></div><span className="chev">{open === x.id ? '⌄' : '›'}</span></div>
            {open === x.id && (
              <div style={{ padding: '4px 12px 14px', background: 'var(--surface2)' }}>
                {x.id === 'pl' && <L.PLScreen data={data} role={role} monthKey={monthKey} onRefresh={refresh} />}
                {x.id === 'plan' && <>
                  <L.PlanLoader onRefresh={refresh} monthKey={monthKey} data={data} role={role} />
                  {data?.plan && role === 'director' && <div style={{ marginTop: 12 }}><L.CloseMonthButton plan={data.plan} onRefresh={refresh} /></div>}
                </>}
                {x.id === 'rit' && <L.Ritase data={data} />}
                {x.id === 'piut' && <Piutang />}
              </div>
            )}
          </div>
        ))}
      </div>
      <AccurateSync />
      <div className="group">
        <div className="row tap" onClick={() => setUi('old')}><div className="grow"><div className="t" style={{ fontWeight: 600 }}>Tampilan lama</div><div className="m">Kembali ke layar sebelumnya. Bisa kembali ke sini kapan saja.</div></div><span className="chev">›</span></div>
        <a className="row tap" href="https://skl-ops.ptmercusuar.com" style={{ color: 'inherit', textDecoration: 'none' }}><div className="grow"><div className="t">Ops</div></div><span className="chev">›</span></a>
        <a className="row tap" href="https://skl.ptmercusuar.com" style={{ color: 'inherit', textDecoration: 'none' }}><div className="grow"><div className="t">Semua aplikasi (SKL)</div></div><span className="chev">›</span></a>
        {/* Phone has no sidebar account corner: same links here (15 Oct). */}
        {role === 'director' && <a className="row tap" href="https://skl.ptmercusuar.com/#akses" style={{ color: 'inherit', textDecoration: 'none' }}><div className="grow"><div className="t">Pengguna & akses</div><div className="m">Siapa bisa membuka Arus Kas dan Ops · di SKL</div></div><span className="chev">›</span></a>}
      </div>
      <div className="group">
        <div className="row"><div className="grow"><div className="t">{user.name}</div><div className="m">{({ director: 'Direktur', staff: 'Staf', viewer: 'Viewer' })[role] || role} · {user.email}{appVersion ? ` · v${appVersion}` : ''}</div></div><button type="button" className="btn ghost small" onClick={logout}>Keluar</button></div>
      </div>
    </div>
  );
}

// Accurate Online copy: when it last ran and a manual "sync now" (Director).
// Nightly at ~02:00 WIB on the server; read-only on the Accurate side.
function AccurateSync() {
  const { api, role, refresh } = useV2();
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.accurateSyncStatus().then(setSt).catch(() => setSt({}));
  useEffect(() => { load(); }, []);
  // Start, then check every 5 s until a run finishes after the click (a nightly run already in progress counts) (max ~4 min).
  const run = async () => {
    setBusy(true);
    const clicked = Date.now() - 5000;
    try {
      await api.runAccurateSync(false);
      for (let i = 0; i < 48; i++) {
        await new Promise(r => setTimeout(r, 5000));
        const s = await api.accurateSyncStatus();
        setSt(s);
        if (s.last?.finished_at && Date.parse(s.last.finished_at) >= clicked) { if (!s.last.ok) alert(s.last.detail?.error || 'Sinkron gagal'); await refresh(); break; }
      }
    } catch (e) { alert(e.message); }
    setBusy(false);
  };
  const last = st?.last, ok = st?.lastOk;
  const when = t => new Date(t).toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  return (
    <div className="group">
      <div className="row"><div className="grow"><div className="t" style={{ fontWeight: 600 }}>Accurate Online</div>
        <div className="m">{!st ? 'Memuat…' : ok ? `Sinkron terakhir ${when(ok.finished_at || ok.started_at)} · ${ok.detail?.entries ?? '—'} entri bank, ${ok.detail?.invoices ?? '—'} faktur` : 'Belum pernah sinkron'}{last && last.ok === false ? ` · gagal ${when(last.started_at)}` : ''} · otomatis tiap malam ±02.00</div></div>
        {role === 'director' && <button type="button" className="btn ghost small" disabled={busy} onClick={run}>{busy ? 'Sinkron…' : 'Sinkron sekarang'}</button>}
      </div>
    </div>
  );
}
